// OGNI motion (restrained): section text fades up once as it enters view,
// the roast timeline line draws once. Hero motion is pure CSS.
// Images are never animated. Nothing runs during scroll except one observer.
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Hero film: the browser plays it (no script per frame). Pause it when it is
// off screen so scrolling the rest of the page stays smooth; keep the still
// frame for reduced-motion and data-saver visitors.
document.querySelectorAll('[data-ogni-film]').forEach((film) => {
  const saveData = navigator.connection && navigator.connection.saveData;
  if (reduce || saveData) {
    film.removeAttribute('autoplay');
    film.preload = 'none';
    film.pause();
    film.hidden = true;
    return;
  }
  film.muted = true;
  const play = () => film.play().catch(() => {});
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) play();
        else film.pause();
      },
      { rootMargin: '200px 0px' },
    ).observe(film);
  } else {
    play();
  }
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && film.getBoundingClientRect().bottom > 0) play();
  });
});

if (!reduce && 'IntersectionObserver' in window) {
  const targets = document.querySelectorAll(
    'main .ogni-section__head, main .ogni-text-block, main .ogni-voice__inner',
  );
  const vh = window.innerHeight;
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px' },
  );
  targets.forEach((el) => {
    if (el.closest('.ogni-hero')) return;
    // Anything already on screen at load stays put (no flash).
    if (el.getBoundingClientRect().top < vh) return;
    el.setAttribute('data-reveal', '');
    io.observe(el);
  });
  document.querySelectorAll('.ogni-flow').forEach((el) => io.observe(el));
  document.documentElement.classList.add('ogni-motion-ready');
}
